import React from 'react';
import Seo from '../common/Seo';

import CallToAction from "../common/CallToAction";
import Drawer from "../common/Drawer";
import Projects from "../home/Projects";
import PageTitle from "./include/PageTitle";

import { ReactComponent as ProjectManagementIcon } from "../assets/skills/project_management.svg";
import OtherSkills from "./include/OtherSkills";
import SkillProjects from "./include/Projects";
import Process from "./include/Process";
import Stack from "./include/Stack";

import { routeIds } from "../i18n/routes";
import { useI18n } from "../i18n/I18nContext";
import ProjectQuery from "../model/Projects";

import Git from "../assets/skills/Git.png";
import GitLab from "../assets/skills/GitLab.png";
import Atlassian from "../assets/skills/Atlassian.png";
import Notion from "../assets/skills/Notion.png";
import Slack from "../assets/skills/Slack.png";

function ProjectManagement({route}) {
    const { pathFor, t } = useI18n();
    const steps = t("expertise.projectManagement.steps");
    const projects = ProjectQuery({filter: "project-management"});
    const techs = [
      { name: "Git", logo: Git },
      { name: "GitLab", logo: GitLab },
      { name: "Atlassian", logo: Atlassian },
      { name: "Notion", logo: Notion },
      { name: "Slack", logo: Slack }
    ];

    const title = t("expertise.projectManagement.title");
    const description = t("expertise.projectManagement.description");

  return [
    <Seo title={title} description={description} />,
    <PageTitle id="gestion-projet" title={t("expertise.projectManagement.heading")} text={t("expertise.projectManagement.intro")} logo={<ProjectManagementIcon />} />,
    <div className="hidden bg-yellow"></div>,
    <Process steps={steps} color="yellow" />,
    <SkillProjects items={projects} color="yellow" />,
    <Stack techs={techs} />,
    <CallToAction id="contact" title={t("expertise.projectManagement.ctaTitle")} text={t("expertise.projectManagement.ctaText")} action={t("common.contactUs")} href={pathFor(routeIds.contact)} />,
    <OtherSkills mainSkill="project-management" />,
    <Projects />,
    <Drawer route={route} />
  ];
}

export default ProjectManagement;
